import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import ReactSelectMaterialUi from 'react-select-material-ui';
import Typography from '@material-ui/core/Typography';
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Modal,
  Radio,
  RadioGroup,
  TableBody,
  TextField
} from '@material-ui/core';
import RequiredButton from '../../components/atoms/RequiredButton';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import { sendLogin } from '../../auth/Auth';
import {
  getGroupsSpecialGochiKid,
  getShopsGroupSpecialGochiKid,
  getMenusGochiKid,
  GET_MENUS_GOCHI_KID_SUCCESS,
  GET_GROUPS_SPECIAL_GOCHI_KID_SUCCESS,
  GET_SHOPS_GROUP_SPECIAL_GOCHI_KID_SUCCESS
} from '../../actions/Options';
import ValidationText from '../../components/atoms/ValidationText';
import {
  GET_IDENTITY_USER_KIDS_SUCCESS,
  getIdentityUserKids
} from '../../actions/Identity';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import AdminUseGochiKidAddConfirm from './AdminUseGochiKidAddConfirm';
import {
  ADMIN_USE_GOCHI_KID_GROUP_SPECIAL_SUCCESS,
  adminUseGochiKidGroupSpecial
} from '../../actions/Gochis';
import {
  GET_LIST_USER_KID_CAN_USE_GROUP_SPECIAL_SUCCESS,
  getListUserKidCanUseGroupSpecial
} from '../../actions/Users';
import taxRatePercent from '../../constants/taxRate';
import usageTypes from '../../constants/UsageType';

const styles = theme => ({
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: 16
    }
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginBottom: 10
    }
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 5px'
    },
    display: 'flex',
    flexDirection: 'column'
  },
  alignEnd: {
    alignSelf: 'end'
  },
  editTable: {
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    },
    '& tr': {
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    }
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '500px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  button: {
    margin: '5px auto'
  },
  priceCalc: {
    margin: '0px 5px',
    color: '#aaa'
  },
  colLeft: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingBottom: 5
    }
  },
  colRight: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingTop: 0
    }
  },
  width100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'block',
      padding: 0
    }
  },
  displayFlex: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingTop: 0
    }
  },
  displayBlock: {
    display: 'block'
  },
  textMutiple: {
    paddingTop: '46px',
    width: '33px'
  },
  textFieldPriceCombo: {
    padding: '0px 5px 0px 5px',
    width: '200px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  situationPulldown: {
    width: '100%',
    margin: '16px 0px 8px'
  },
  pulldownHeight: {
    maxHeight: '350px'
  },
  userKid: {
    display: 'inline-flex',
    flexDirection: 'row'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      // account: state.accounts.account,
      name: state.loginInfo.name,
      detail: state.gochiMenus.detail,
      shops: state.shops.shops,
      // shops: state.options.listShops,
      groups: state.options.listGroups,
      taxTypes: state.gochiMenus.taxTypes,
      reducedTaxMenuPrefix: state.commons.reducedTaxMenuPrefix
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getIdentityUserKids,
          getMenusGochiKid,
          getGroupsSpecialGochiKid,
          getShopsGroupSpecialGochiKid,
          getListUserKidCanUseGroupSpecial,
          adminUseGochiKidGroupSpecial
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('loading', 'updateLoading', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('openAddConfirm', 'updateOpenAddConfirm', false),
  withState('openProgressConfirm', 'updateOpenProgressConfirm', false),
  withState('resultMessage', 'updateResultMessage', ''),
  withState('errorMessage', 'updateErrorMessage', ''),
  withState('userEmailInput', 'setUserEmailInput', null),
  withState('userEmailInputTmp', 'setUserEmailInputTmp', null),
  withState('userGochiKidId', 'setUserGochiKidId', 0),
  withState('userName', 'setUserName', ''),
  withState('userGochiKidError', 'setUserGochiKidError', ''),
  withState('groupSpecials', 'setGroupSpecials', []),
  withState('groupGochiKidId', 'setGroupGochiKidId', 0),
  withState('groupGochiKidError', 'setGroupGochiKidError', ''),
  withState('shops', 'setShops', []),
  withState('shopId', 'setShopId', 0),
  withState('shopNameError', 'setShopNameError', ''),
  withState('menus', 'setMenus', []),
  withState('menuId', 'setMenuId', 0),
  withState('menuNameError', 'setMenuNameError', ''),
  withState('usedAmount', 'setUsedAmount', 0),
  withState('usedAmountError', 'setUsedAmountError', ''),
  withState('usedAt', 'setUsedAt', null),
  withState('usedAtError', 'setUsedAtError', ''),
  withState('userKids', 'setUserKids', []),
  withState('userKidIdsAdd', 'setUserKidIdsAdd', []),
  withState('userKidIdsAddError', 'setUserKidIdsAddError', ''),
  withState('getMenusSuccessFlag', 'setGetMenusSuccessFlag', false),
  withState('usageType', 'setUsageType', null),
  withState('taxRate', 'setTaxRate', taxRatePercent.TAX_RATE_10_PERCENT),
  withState(
    'shopAllowMenuPriceGochiKid',
    'setShopAllowMenuPriceGochiKid',
    null
  ),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes, // searchKey,
    checkSession,
    actions,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    updateResultMessage,
    errorMessage,
    updateErrorMessage,
    updateOpenAdd,
    openAddConfirm,
    updateOpenAddConfirm,
    openProgressConfirm,
    updateOpenProgressConfirm,
    userEmailInput,
    setUserEmailInput,
    userEmailInputTmp,
    setUserEmailInputTmp,
    userName,
    setUserName,
    userGochiKidId,
    setUserGochiKidId,
    userGochiKidError,
    setUserGochiKidError,
    groupGochiKidId,
    setGroupGochiKidId,
    groupSpecials,
    setGroupSpecials,
    groupGochiKidError,
    setGroupGochiKidError,
    shops,
    setShops,
    shopId,
    setShopId,
    shopNameError,
    setShopNameError,
    menus,
    setMenus,
    menuId,
    setMenuId,
    menuNameError,
    setMenuNameError,
    usedAmount,
    setUsedAmount,
    usedAmountError,
    setUsedAmountError,
    usedAt,
    setUsedAt,
    usedAtError,
    setUsedAtError,
    userKids,
    setUserKids,
    userKidIdsAdd,
    setUserKidIdsAdd,
    userKidIdsAddError,
    setUserKidIdsAddError,
    handleChangePage,
    page,
    limit,
    getMenusSuccessFlag,
    setGetMenusSuccessFlag,
    taxRate,
    setTaxRate,
    usageType,
    setUsageType,
    shopAllowMenuPriceGochiKid,
    setShopAllowMenuPriceGochiKid
  }) => {
    const errors = {
      userGochiKidError,
      shopNameError,
      menuNameError,
      usedAmountError,
      usedAtError,
      userKidIdsAddError,
      groupGochiKidError
    };

    const menuPriceObj = { label: '金額指定メニュー', value: '-1' };

    const USAGE_TYPE_MENU = usageTypes[0].id;
    const USAGE_TYPE_VOUCHER = usageTypes[1].id;

    const validUserGochiKid = () => {
      const value = userGochiKidId;
      if (value === 0) {
        setUserGochiKidError('必須項目です。');
        return 1;
      }
      setUserGochiKidError('');
      setUserGochiKidId(value);
      return 0;
    };

    const validShopName = () => {
      const value = shopId;
      if (value === 0) {
        setShopNameError('必須項目です。');
        return 1;
      }
      setShopNameError('');
      setShopId(value);
      return 0;
    };

    const validGroupGochiKid = () => {
      const value = groupGochiKidId;
      if (value === 0) {
        setGroupGochiKidError('必須項目です。');
        return 1;
      }
      setGroupGochiKidError('');
      setGroupGochiKidId(value);
      return 0;
    };

    const validMenuName = () => {
      const value = menuId;
      if (value === 0) {
        setMenuNameError('必須項目です。');
        return 1;
      }
      setMenuNameError('');
      setMenuId(value);
      return 0;
    };

    const validUsedAmount = () => {
      const value = usedAmount;
      const shopChoose = shops.find(shop => shop.shopId === shopId);
      if (value === '') {
        setUsedAmountError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setUsedAmountError('半角数字のみ入力してください。');
        return 1;
      }
      if (value <= 0) {
        setUsedAmountError('必須項目です。');
        return 1;
      }
      if (value > 1000 && shopChoose && shopChoose.gochiKidUnlimit !== 1) {
        setUsedAmountError('1000円までご入力ください');
        return 1;
      }
      setUsedAmountError('');
      setUsedAmount(value);
      return 0;
    };

    const validUsedAt = () => {
      const value = usedAt;
      if (value === null) {
        setUsedAtError('必須項目です。');
        return 1;
      }
      setUsedAtError('');
      setUsedAt(value);
      return 0;
    };

    const validUserKidIdsAdd = () => {
      const value = userKidIdsAdd;
      if (value.length <= 0) {
        setUserKidIdsAddError('必須項目です。');
        return 1;
      }
      setUserKidIdsAddError('');
      setUserKidIdsAdd(value);
      return 0;
    };

    const valid = () => {
      let errorCount = 0;
      errorCount =
        validUserGochiKid() +
        validGroupGochiKid() +
        validShopName() +
        validMenuName() +
        (parseInt(menuId, 10) === parseInt(menuPriceObj.value, 10)
          ? validUsedAmount()
          : 0) +
        validUsedAt() +
        validUserKidIdsAdd();
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const getShopOptions = () => {
      const shopOptions = [];
      const tmpObj = { label: '', value: '0' };
      shops.forEach(shop => {
        shopOptions.push({
          label: shop.shopName,
          value: String(shop.shopId)
        });
      });
      return { ...shopOptions, tmpObj };
    };

    const getMenuGochiKidOptions = () => {
      const menuOptions = [];
      const tmpObj = { label: '', value: '0' };

      if (getMenusSuccessFlag && shopAllowMenuPriceGochiKid === 1) {
        menuOptions.push({
          label: menuPriceObj.label,
          value: String(menuPriceObj.value)
        });
      }

      menus.forEach(menu => {
        menuOptions.push({
          label: menu.menuName,
          value: String(menu.menuId)
        });
      });
      return { ...menuOptions, tmpObj };
    };

    const getGroupGochiKidOptions = () => {
      const groupOptions = [];
      const tmpObj = { label: '', value: '0' };
      groupSpecials.forEach(group => {
        groupOptions.push({
          label: group.gochiKidGroupName,
          value: String(group.gochiKidGroupId)
        });
      });
      return { ...groupOptions, tmpObj };
    };

    const handleChangeShopName = async shopIdNew => {
      const shopChoose = shops.find(shop => shop.shopId === shopIdNew);

      setShopId(shopIdNew);
      updateOpenProgress(true);
      updateLoading(true);
      setMenuId(0);
      setUsageType(null);
      setTaxRate(taxRatePercent.TAX_RATE_10_PERCENT);
      setMenuNameError('');
      setUsedAmount(0);
      setUsedAmountError('');
      setGetMenusSuccessFlag(false);
      setShopAllowMenuPriceGochiKid(
        shopChoose ? shopChoose.allowMenuPriceGochiKid : null
      );

      if (shopIdNew !== 0) {
        const menusData = await actions
          .getMenusGochiKid({
            shopId: shopIdNew,
            gochiKidGroupId: groupGochiKidId,
            page: 1,
            limit: 1000000000
          })
          .then(data => checkSession(data));
        if (menusData.type === GET_MENUS_GOCHI_KID_SUCCESS) {
          setGetMenusSuccessFlag(true);
          setMenus(menusData.payload.list);
        } else {
          setGetMenusSuccessFlag(false);
          setMenus([]);
        }
      } else {
        setGetMenusSuccessFlag(false);
        setMenus([]);
      }
      updateLoading(false);
      updateOpenProgress(false);
    };

    const handleChangeMenuName = menuIdNew => {
      setUsedAmount(0);
      setUsedAmountError('');
      setMenuId(menuIdNew);
      const menu = menus.find(m => m.menuId === menuIdNew);
      if (menu) {
        setUsageType(menu.usageType);
        if (menu.usageType === USAGE_TYPE_MENU) {
          setTaxRate(menu.taxRate);
        } else {
          setTaxRate(taxRatePercent.TAX_RATE_10_PERCENT);
        }
      } else {
        setUsageType(null);
        setTaxRate(taxRatePercent.TAX_RATE_10_PERCENT);
      }
    };

    const handleChangeUserGochiKid = async () => {
      if (userEmailInput === userEmailInputTmp) return;
      setUserEmailInputTmp(userEmailInput);
      setUserGochiKidId(0);
      setUserName('');
      setUserGochiKidError('');
      setGroupSpecials([]);
      setGroupGochiKidId(0);
      setGroupGochiKidError('');
      setShops([]);
      setShopId(0);
      setShopNameError('');
      setMenus([]);
      setMenuId(0);
      setUsageType(null);
      setTaxRate(taxRatePercent.TAX_RATE_10_PERCENT);
      setMenuNameError('');
      setUsedAmount(0);
      setUsedAmountError('');
      const pattern = new RegExp(
        /^(("[\w+-\s]+")|([\w+-]+(?:\.[\w+-]+)*)|("[\w+-\s]+")([\w+-]+(?:\.[\w+-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );

      if (!userEmailInput) {
        setUserGochiKidError('必須項目です。');
        return;
      }

      if (!pattern.test(userEmailInput)) {
        setUserGochiKidError('メールアドレスを正しく入力してください。');
        return;
      }

      updateOpenProgress(true);
      updateLoading(true);
      const userData = await actions
        .getIdentityUserKids({
          page: 1,
          limit: 1,
          userKidStatus: 'OK',
          email: userEmailInput
        })
        .then(data => checkSession(data));

      if (
        userData.type === GET_IDENTITY_USER_KIDS_SUCCESS &&
        userData.payload.list &&
        userData.payload.list.length > 0
      ) {
        setUserGochiKidId(userData.payload.list[0].userId);
        setUserName(userData.payload.list[0].displayName);
        const groupSpecialsData = await actions
          .getGroupsSpecialGochiKid({
            userId: userData.payload.list[0].userId,
            page: 1,
            limit: 1000000000
          })
          .then(data => checkSession(data));
        if (groupSpecialsData.type === GET_GROUPS_SPECIAL_GOCHI_KID_SUCCESS) {
          setGroupSpecials(groupSpecialsData.payload.list);
        } else {
          setGroupSpecials([]);
        }
      } else {
        setUserGochiKidError('メールアドレスが存在していません');
      }
      updateOpenProgress(false);
      updateLoading(false);
    };

    const handleChangeGroupGochiKid = async gochiKidGroupId => {
      setGroupGochiKidId(gochiKidGroupId);
      setShops([]);
      setShopId(0);
      setShopNameError('');
      setShopAllowMenuPriceGochiKid(null);
      setMenus([]);
      setMenuId(0);
      setUsageType(null);
      setTaxRate(taxRatePercent.TAX_RATE_10_PERCENT);
      setMenuNameError('');
      setUsedAmount(0);
      setUsedAmountError('');
      updateOpenProgress(true);
      updateLoading(true);
      const shopData = await actions
        .getShopsGroupSpecialGochiKid(gochiKidGroupId, {
          page: 1,
          limit: 1000000000,
          userId: userGochiKidId
        })
        .then(data => checkSession(data));
      if (shopData.type === GET_SHOPS_GROUP_SPECIAL_GOCHI_KID_SUCCESS) {
        setShops(shopData.payload.list);
      } else {
        setShops([]);
      }
      updateOpenProgress(false);
      updateLoading(false);
    };

    const handleChangeUserKid = (checked, userKidId) => {
      if (checked) {
        setUserKidIdsAdd([...userKidIdsAdd, userKidId]);
      } else {
        setUserKidIdsAdd(userKidIdsAdd.filter(item => item !== userKidId));
      }
    };

    const handleChangeUsedAtDate = value => {
      if (value) {
        const newVal = moment(value);
        const res = usedAt ? moment(usedAt) : moment();
        res.set({
          year: newVal.get('year'),
          date: newVal.get('date'),
          month: newVal.get('month')
        });
        setUsedAt(res.format('YYYY-MM-DDTHH:mm:ss'));
      } else {
        setUsedAt(null);
      }
    };

    const cancelAction = () => updateOpenAdd(false);

    const backAction = () => updateOpenAddConfirm(false);

    const confirmAction = () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        updateOpenAddConfirm(true);
      }
    };

    const registerAction = async () => {
      updateLoading(true);
      updateOpenProgressConfirm(true);
      const response = await actions
        .adminUseGochiKidGroupSpecial({
          userId: userGochiKidId,
          usedAt,
          menuId:
            parseInt(menuId, 10) !== parseInt(menuPriceObj.value, 10)
              ? parseInt(menuId, 10)
              : null,
          shopId,
          gochiKidGroupId: groupGochiKidId,
          userKidIds: userKidIdsAdd,
          usedAmount:
            parseInt(menuId, 10) === parseInt(menuPriceObj.value, 10)
              ? usedAmount
              : null,
          taxRate
        })
        .then(data => checkSession(data));
      if (response.type === ADMIN_USE_GOCHI_KID_GROUP_SPECIAL_SUCCESS) {
        updateResultMessage('データ登録が完了しました。');
        updateLoading(false);
      } else {
        updateLoading(false);
        updateOpenProgressConfirm(false);
        if (
          response.error &&
          response.payload.data &&
          response.payload.data.errorInfo &&
          response.payload.data.errorInfo.content
        ) {
          updateErrorMessage(response.payload.data.errorInfo.content);
        } else {
          updateErrorMessage('エラーが発生しました！');
        }
      }
    };

    const progressOkAction = async () => {
      await handleChangePage(null, page, limit);
      updateResultMessage('');
      updateOpenProgressConfirm(false);
      updateOpenAdd(false);
      updateOpenAddConfirm(false);
    };

    const getUserKidCanUse = async (
      userIdParam,
      usedAtParam,
      groupGochiKidIdParam
    ) => {
      const response = await actions
        .getListUserKidCanUseGroupSpecial({
          userId: userIdParam,
          usedAt: `${usedAtParam}.000`,
          gochiKidGroupId: groupGochiKidIdParam
        })
        .then(data => checkSession(data));
      if (response.type === GET_LIST_USER_KID_CAN_USE_GROUP_SPECIAL_SUCCESS) {
        setUserKids(response.payload.data.list);
      } else {
        setUserKids([]);
      }
    };

    useEffect(() => {
      setUserKids([]);
      setUserKidIdsAdd([]);
      setUserKidIdsAddError('');
      if (userGochiKidId && userGochiKidId !== 0 && usedAt && groupGochiKidId) {
        getUserKidCanUse(userGochiKidId, usedAt, groupGochiKidId);
      }
    }, [userGochiKidId, usedAt, groupGochiKidId]);

    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography variant="h6">こどもごちめし利用データ登録</Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.editTable}>
            <TableBody>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    required
                    label="メールアドレス"
                    className={classes.textField}
                    margin="normal"
                    value={userEmailInput}
                    onChange={e => {
                      setUserEmailInput(e.target.value.trim());
                    }}
                    onBlur={handleChangeUserGochiKid}
                  />
                  <TextField
                    label="ユーザー名"
                    className={classes.textField}
                    margin="normal"
                    value={userName}
                    InputLabelProps={{
                      shrink: true
                    }}
                    disabled
                  />
                  <ValidationText message={errors.userGochiKidError} />
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <ReactSelectMaterialUi
                    required
                    label="資金グループ*"
                    className={classes.textField}
                    value={String(groupGochiKidId)}
                    options={getGroupGochiKidOptions()}
                    margin="normal"
                    onChange={v => {
                      handleChangeGroupGochiKid(Number(v));
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter:
                        '名前が部分一致する店舗がありません'
                    }}
                    onBlur={validGroupGochiKid}
                  />
                  <ValidationText message={errors.groupGochiKidError} />
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <ReactSelectMaterialUi
                    required
                    label="店舗名*"
                    className={classes.textField}
                    value={String(shopId)}
                    options={getShopOptions()}
                    margin="normal"
                    onChange={v => {
                      handleChangeShopName(Number(v));
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter:
                        '名前が部分一致する店舗がありません'
                    }}
                    onBlur={validShopName}
                  />
                  <ValidationText message={errors.shopNameError} />
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <div style={{ display: 'flex' }}>
                    <div>
                      <ReactSelectMaterialUi
                        required
                        label="メニュー名*"
                        className={classes.textField}
                        value={String(menuId)}
                        options={getMenuGochiKidOptions()}
                        margin="normal"
                        onChange={v => {
                          handleChangeMenuName(Number(v));
                        }}
                        SelectProps={{
                          isClearable: true,
                          msgNoOptionsMatchFilter:
                            '名前が部分一致する店舗がありません'
                        }}
                        onBlur={validMenuName}
                      />
                      <ValidationText message={errors.menuNameError} />
                    </div>
                    {parseInt(menuId, 10) ===
                      parseInt(menuPriceObj.value, 10) && (
                      <div>
                        <TextField
                          required
                          label="利用税込金額"
                          className={classes.textField}
                          margin="normal"
                          value={usedAmount}
                          onChange={e => {
                            setUsedAmount(e.target.value.trim());
                          }}
                          onBlur={validUsedAmount}
                        />
                        <ValidationText message={errors.usedAmountError} />
                      </div>
                    )}
                  </div>
                </TableCell>
                <TableCell />
              </TableRow>
              {(parseInt(menuId, 10) === parseInt(menuPriceObj.value, 10) ||
                usageType === USAGE_TYPE_VOUCHER) && (
                <TableRow>
                  <TableCell className={classes.colLeft}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <Typography
                      style={{
                        fontSize: '14px',
                        fontWeight: '400',
                        color: 'rgba(0, 0, 0, 0.54)'
                      }}
                    >
                      消費税区分*
                    </Typography>
                    <RadioGroup
                      row
                      value={taxRate}
                      onChange={e => {
                        setTaxRate(parseFloat(e.target.value));
                      }}
                    >
                      <FormControlLabel
                        value={taxRatePercent.TAX_RATE_10_PERCENT}
                        control={<Radio color="primary" />}
                        label="10%対象"
                      />
                      <FormControlLabel
                        value={taxRatePercent.TAX_RATE_8_PERCENT}
                        control={<Radio color="primary" />}
                        label="8%対象"
                        style={{ marginLeft: 40 }}
                      />
                    </RadioGroup>
                  </TableCell>
                  <TableCell />
                </TableRow>
              )}
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <div style={{ display: 'flex' }}>
                    <TextField
                      required
                      label="利用日時"
                      type="date"
                      className={classes.textField}
                      margin="normal"
                      InputLabelProps={{
                        shrink: true
                      }}
                      value={
                        usedAt ? moment(usedAt).format('YYYY-MM-DD') : null
                      }
                      onChange={e => {
                        handleChangeUsedAtDate(e.target.value);
                      }}
                      onBlur={validUsedAt}
                    />
                    <TextField
                      type="time"
                      label=" "
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        const newVal = moment(e.target.value, 'HH:mm:ss');
                        const res = usedAt ? moment(usedAt) : moment();
                        res.set({
                          hour: newVal.get('hour'),
                          minute: newVal.get('minute'),
                          second: newVal.get('second')
                        });
                        setUsedAt(res.format('YYYY-MM-DDTHH:mm:ss'));
                      }}
                      onBlur={validUsedAt}
                      value={usedAt ? moment(usedAt).format('HH:mm:ss') : null}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 1
                      }}
                    />
                  </div>
                  <ValidationText message={errors.usedAtError} />
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell>
                  <Typography
                    variant="h6"
                    style={{
                      fontSize: '14px',
                      fontWeight: '400',
                      color: 'rgba(0, 0, 0, 0.54)'
                    }}
                  >
                    利用するお子さま*
                  </Typography>
                  {userGochiKidId !== 0 &&
                    userKids.length > 0 &&
                    userKids.map(userKid => {
                      return (
                        <FormGroup
                          key={userKid.userKidId}
                          className={classes.userKid}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  userKidIdsAdd &&
                                  userKidIdsAdd.length > 0 &&
                                  userKidIdsAdd.includes(userKid.userKidId)
                                    ? userKidIdsAdd.includes(userKid.userKidId)
                                    : false
                                }
                                color="primary"
                                onChange={e => {
                                  handleChangeUserKid(
                                    e.target.checked,
                                    userKid.userKidId
                                  );
                                }}
                                onBlur={validUserKidIdsAdd}
                                disabled={!userKid.canUse}
                              />
                            }
                            style={{ wordBreak: 'break-word' }}
                            label={userKid.displayName}
                          />
                        </FormGroup>
                      );
                    })}
                  <ValidationText message={errors.userKidIdsAddError} />
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
        <div>
          <CancelButton color="primary" onClickAction={cancelAction} />
          <ConfirmButton onClickAction={confirmAction} />
        </div>
        <Modal open={openAddConfirm}>
          <AdminUseGochiKidAddConfirm
            backAction={backAction}
            userGochiKidId={userGochiKidId}
            shopId={shopId}
            menuId={menuId}
            usedAmount={usedAmount}
            usedAt={usedAt}
            userKidIdsAdd={userKidIdsAdd}
            userKids={userKids}
            shops={shops}
            menus={menus}
            userName={userName}
            openAddProgress={openProgressConfirm}
            loading={loading}
            registerAction={registerAction}
            errorMessage={errorMessage}
            updateErrorMessage={updateErrorMessage}
            menuPriceObj={menuPriceObj}
            resultMessage={resultMessage}
            progressOkAction={progressOkAction}
            groupSpecials={groupSpecials}
            groupGochiKidId={groupGochiKidId}
            usageType={usageType}
            taxRate={taxRate}
          />
        </Modal>

        <ProgressDialog
          openProgress={openProgress}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
